import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Gondola, Schedule, SkuSection, WithIndex } from "@/shared/api";
import { Dimensions } from "./types";

type PlanogramState = {
  canvasDimensions: Dimensions;
  selectedGondola: Gondola | null;
  selectedCameraSkuSection: WithIndex<SkuSection> | null;
  isPolygonsVisible: boolean;
  visibleSchedules: Schedule[];
  dateRange: {
    start: Date | null;
    end: Date | null;
  };
};

const initialState: PlanogramState = {
  dateRange: {
    start: null,
    end: null,
  },
  canvasDimensions: {
    width: 0,
    height: 0,
  },
  selectedGondola: null,
  selectedCameraSkuSection: null,
  visibleSchedules: [],
  isPolygonsVisible: true,
};

export const planogramSlice = createSlice({
  name: "planogram",
  initialState,
  selectors: {
    selectCanvasDimensions: (state) => state.canvasDimensions,
    selectIsPolygonsVisible: (state) => state.isPolygonsVisible,
    selectSelectedCameraSkuSection: (state) => state.selectedCameraSkuSection,
    selectSelectedGondola: (state) => state.selectedGondola,
  },
  reducers: {
    setPlanogramDateRange(
      state,
      action: PayloadAction<PlanogramState["dateRange"]>
    ) {
      state.dateRange = action.payload;
    },
    updateCanvasDimensions: (state, action) => {
      state.canvasDimensions = action.payload;
    },
    updateIsPolygonsVisible: (state, action) => {
      state.isPolygonsVisible = action.payload;
    },
    setSelectedCameraSkuSection: (state, action) => {
      state.selectedCameraSkuSection = action.payload;
    },
    setSelectedGondola: (state, action) => {
      state.selectedGondola = action.payload;
    },
    updateVisibleSchedules: (state, action) => {
      state.visibleSchedules = action.payload;
    },
  },
});

export const {
  updateCanvasDimensions,
  updateIsPolygonsVisible,
  setSelectedCameraSkuSection,
  setSelectedGondola,
  updateVisibleSchedules,
  setPlanogramDateRange,
} = planogramSlice.actions;

export const {
  selectCanvasDimensions,
  selectIsPolygonsVisible,
  selectSelectedCameraSkuSection,
  selectSelectedGondola,
} = planogramSlice.selectors;

export const planogramReducer = planogramSlice.reducer;
